import { House } from 'lucide-react'
import { Fragment } from 'react'
import { Link } from 'react-router-dom'

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/frontend/components/ui/breadcrumb'
import { useBreadcrumbs } from '@/frontend/hooks/use-breadcrumbs'

/** App-level breadcrumb bar. Renders whatever the current page has set via useBreadcrumbs. */
export function AppBreadcrumbs() {
  const { crumbs } = useBreadcrumbs()

  if (!crumbs.length) return null

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink render={<Link to="/" />}>
            <House className="size-3.5" />
          </BreadcrumbLink>
        </BreadcrumbItem>
        {crumbs.map((crumb, i) => {
          const isLast = i === crumbs.length - 1
          return (
            <Fragment key={crumb.label}>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                {isLast || !crumb.to ? (
                  <BreadcrumbPage className="font-semibold">{crumb.label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink className="font-medium" render={<Link to={crumb.to} />}>
                    {crumb.label}
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </Fragment>
          )
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
